import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DropdownA from 'components/Dropdown/DropdownA';
import useTabStripRegistration from 'hooks/useTabStripRegistration';
import classes from './SelectA.module.scss';

const {
  arrayOf,
  func,
  number,
  string,
  shape,
} = PropTypes;

const SelectA = (props) => {
  const {
    tabs = [],
    selectedIndex,
    handleClick,
    handleSelect,
    identifier = '',
  } = props;

  const {
    registrationError,
  } = useTabStripRegistration({ identifier, className: '.k-tab-strip' });

  const tab = ({ title }, index) => ( // eslint-disable-line react/prop-types
    <button
      type='button'
      key={index}
      className={classNames(
        classes.tab,
        { [classes.active]: (index === selectedIndex) },
      )}
      onClick={() => handleClick(index)}
      aria-label={title}
    >
      <div className={classes.tabTitle}>
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </div>
    </button>
  );

  const desktop = (
    <div className={classes.desktopContainer}>
      {tabs.map(tab)}
    </div>
  );

  const listDisplay = (item) => (
    <span className={classes.optionWrapper}>
      <span
        className={classes.dropdownTitle}
        dangerouslySetInnerHTML={{ __html: item.title }}
      />
    </span>
  );

  const singleValue = (item) => (
    <span className={classes.singleValueWrapper}>
      <span
        className={classes.dropdownTitle}
        dangerouslySetInnerHTML={{ __html: item.title }}
      />
    </span>
  );

  const customStylesForDropdown = {
    container: (base) => ({ ...base, width: '100%', border: 'none', minHeight: '40px' }),
    control: (base) => ({
      ...base,
      border: '1px solid #dcdcdc',
      borderRadius: '4px',
      height: '100%',
      minHeight: '40px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#00a0d4',
      '&:hover': {
        borderColor: '#00a0d4',
        color: '#00a0d4',
      },
    }),
  };

  const select = tabs.map((item) => ({
    ...item,
    label: item.title,
    renderSingleValue: singleValue(item),
    renderOption: listDisplay(item),
  }));

  const mobile = (
    <div className={classes.mobileContainer}>
      {select.length === 1 && <div className={classes.tabs}>{tab(tabs[0], 0)}</div>}
      {select.length > 1 && <DropdownA
        type='SelectA'
        options={select}
        defaultValue={select[selectedIndex]}
        onChange={handleSelect}
        renderOption='renderOption'
        renderSingleValue='renderSingleValue'
        customStyles={customStylesForDropdown}
        {...props}
      />}
    </div>
  );

  return registrationError || (tabs.length > 0 &&
    <div className={classes.container} id={`TabStrip-${`${identifier ? `${identifier}-` : ''}select`}`}>
      {desktop}
      {mobile}
    </div>);
};

SelectA.propTypes = {
  /**
    Array of tab objects { type, title, color }
  */
  tabs: arrayOf(shape({
    type: string,
    title: string,
  })),
  /**
    Index of selected tab
  */
  selectedIndex: number,
  /**
    Click handler method
  */
  handleClick: func,
  /**
    Select handler method
  */
  handleSelect: func,
  /**
    Identifier for component
  */
  indentifier: string,
};

export default SelectA;
